const user = {
    idKey: 'devId',
    userKey: 'devOwner'
};

export default user;